import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setFields, setFile} from '../../store/builder/reducer';
import {useUploadFileMutation} from '../../store/builder/inspections.api';
import {useParams} from 'react-router-dom';
import useLoader from '../../global/UseLoadingHandler';
import {toast} from 'react-toastify';
import {useTranslation} from '../../hooks/useTranslation';

export default function FillInput({
  option,
  type,
  item,
  index,
  radioOptions,
  setRadioOptions,
  sheet,
  inspection_id,
  readOnly,
  disabled,
  answer,
  setCurrentItem,
  currentItem,
}) {
  const {t} = useTranslation();
  const [showImages, setShowImages] = useState(null);
  const [checked, setChecked] = useState(false);
  const [checkedData, setCheckedData] = useState(null);
  const [count, setCount] = useState(0);
  const fields = useSelector(state => state.rootReducer.reducer.fields);
  const dispatch = useDispatch();
  const params = useParams();
  const [uploadFile, {data, isSuccess, isLoading, isError}] =
    useUploadFileMutation();

  useLoader([isLoading]);

  let guid = () => {
    let s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };
    return (
      s4() +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  };
  const handleFile = e => {
    const selectedFiles = e.target.files;
    const selectedFilesArray = Array.from(selectedFiles);
    if (selectedFiles.length > 5) {
      toast.error('Maximum 5 files allowed!');
      return;
    }
    const imagesArray = selectedFilesArray.map(file => {
      return URL.createObjectURL(file);
    });
    setShowImages({preview: imagesArray[0], data: imagesArray});

    for (let i = 0; i < e.target.files.length; i++) {
      const form = new FormData();
      form.append('file', e.target.files[i]);
      form.append('type', 'inspection');
      form.append('inspection_id', inspection_id);
      form.append('category_id', item.id);
      form.append('uuid', guid());

      uploadFile(form).then(res => {
        dispatch(setFile({id: item.id, file: res?.data?.data?.uuid}));
      });
    }
  };
  const removeCommentImage = (indexToRemove, fromServer = false) => {
    if (fromServer) {
      const newCommentFiles = (item?.comment_files || []).filter(
        (_, i) => i !== indexToRemove,
      );
      dispatch(
        setFields({
          id: item.id,
          comment_files: newCommentFiles,
        }),
      );
    } else {
      setShowImages(old => {
        const arr = old?.data?.filter((_, i) => i !== indexToRemove) ?? [];
        return {preview: arr[0], data: arr};
      });
      const newCommentFiles = (item?.comment_files || []).filter(
        (_, i) => i !== indexToRemove,
      );
      dispatch(
        setFields({
          id: item.id,
          comment_files: newCommentFiles,
        }),
      );
    }
  };

  const renderImages = () => {
    return showImages?.data?.map((img, index) => (
      <div key={index} className='fillInspection__field-commentImage'>
        {!readOnly && !disabled && (
          <div
            className='fillInspection__field-commentImageDel fillInspection__field-commentImageDel--visible'
            onClick={() => removeCommentImage(index, false)}
            role='button'
            aria-label='Remove image'
          >
            <img src='/assets/icons/trash2.svg' alt='trash' />
          </div>
        )}
        <img
          className='fillInspection__field-commentImg'
          src={img}
          alt=''
        />
      </div>
    ));
  };

  // Normalize "Y"/"N" and "Yes"/"No" so radio checked state matches stored value
  const normalizeRadioValue = val => {
    if (val === 'Y' || val === 'Yes' || val === 'yes') return 'Y';
    if (val === 'N' || val === 'No' || val === 'no') return 'N';
    return val;
  };
  const isOptionChecked = (optVal, answer) =>
    optVal === answer || normalizeRadioValue(optVal) === normalizeRadioValue(answer);

  const changeOptionStatus = e => {
    if (type === 'checkbox') {
      setChecked(e.target.checked);
    }
    if (type === 'radio') {
      if (e.target.checked) {
        let data = radioOptions?.map((elem, idx) => {
          if (idx === index) {
            elem.checked = e.target.checked;
          } else {
            elem.checked = false;
          }
          return elem;
        });
        setRadioOptions(data);
        setChecked(e.target.checked);
      }
    }
  };
  useEffect(() => {
    if (checkedData?.id) {
      dispatch(
        setFields({
          ...checkedData,
          id: checkedData.id,
          comment_text: checkedData?.comment_text,
        }),
      );
    }
  }, [checkedData]);

  useEffect(() => {
    if (count < 2) {
      if (item?.data_type === 'fsii_available') {
        setRadioOptions(old => {
          return old.map(s => {
            if (isOptionChecked(s?.value, item?.answers?.[0])) {
              s.checked = true;
            }
            return s;
          });
        });
      } else {
        setRadioOptions(
          radioOptions?.map(opt => {
            if (isOptionChecked(opt?.value, item?.answers?.[0])) {
              opt.checked = true;
            }
            return opt;
          }),
        );
      }
      setCount(count + 1);
    }
  }, [radioOptions]);

  useEffect(() => {
    if (type === 'checkbox') {
      fields?.forEach(field => {
        field?.answers?.forEach(answer => {
          if (answer === option.value) {
            setChecked(true);
          }
        });
      });
    }
  }, []);

  useEffect(() => {
    currentItem?.fields?.forEach(field => {
      if (field.id === item?.id) {
        field?.options?.forEach(option => {
          if (option?.from_corrective_action) {
            setCheckedData({
              id: item.id,
              has_comment: option.has_comment,
              comment_text: field.comment_text,
              comment_files: item.comment_files,
              answers: [`${option.value}`],
            });
          }
        });
      }
    });
  }, [currentItem]);

  return (
    <>
      <div className='fillInspection__field-optionBox'>
        <label className={'fillInspection__field-' + type}>
          {option?.label}
          <input
            name={item.id}
            type={type === 'radio' ? 'checkbox' : 'checkbox'}
            data-comment={option?.has_comment}
            disabled={readOnly || disabled ? true : sheet ? true : false}
            onChange={e => {
              if (e.target.checked) {
                if (type === 'radio') {
                  setCheckedData({
                    id: item.id,
                    has_comment: option.has_comment,
                    comment_text: '',
                    comment_files: item.comment_files,
                    answers: [`${option.value}`],
                  });
                } else {
                  let data = [
                    ...fields?.filter(field => field.id === item.id),
                  ][0];
                  setCheckedData({
                    id: item.id,
                    has_comment: option.has_comment,
                    comment_text: '',
                    comment_files: item.comment_files,
                    answers: [...data?.answers, e.target.value],
                  });
                }
              } else {
                if (type !== 'radio') {
                  let data = [
                    ...fields?.filter(field => field.id === item.id),
                  ][0];
                  let answers =
                    data?.answers?.length > 1
                      ? data?.answers?.filter(
                          answer => answer !== e.target.value,
                        )[0]
                      : '';
                  setCheckedData({
                    id: item.id,
                    has_comment: option.has_comment,
                    comment_text: '',
                    comment_files: item.comment_files,
                    answers: [answers],
                  });
                }
              }
              changeOptionStatus(e);
            }}
            value={option.value}
            checked={type === 'radio' ? radioOptions[index]?.checked : checked}
          />
          <span
            className={`checkmark${type === 'checkbox' ? '-checkbox' : ''} `}
          >
            {type === 'checkbox' && (
              <img src='/assets/icons/check.svg' alt='' />
            )}
          </span>
        </label>
      </div>
      {(type === 'radio' ? radioOptions[index]?.checked : checked) &&
        option?.has_comment && (
          <div className='fillInspection__field-comment'>
            <p className='fillInspection__field-commentName'>
              {t('toolsRow.labels.comment')}
            </p>
            <textarea
              maxLength={255}
              placeholder={t('fillField.commentPlaceholder')}
              className='fillInspection__field-commentArea'
              defaultValue={item?.comment_text}
              disabled={readOnly ? true : sheet ? true : false}
              onChange={e => {
                setCheckedData(old => ({
                  ...old,
                  comment_text: e?.target?.value,
                  comment_files: item?.comment_files,
                }));
                const currentField = fields?.find(f => f.id === item.id);
                if (currentField) {
                  dispatch(
                    setFields({
                      id: item.id,
                      has_comment: true,
                      comment_text: e?.target?.value,
                      comment_files: currentField.comment_files,
                      answers: currentField.answers,
                    }),
                  );
                }
              }}
            ></textarea>
            {item.data_type ===
            'fsii_condition' ? null : item?.comment_files ? (
              !showImages?.preview && !item?.comment_files[0]?.url ? (
                <div className='fillInspection__field-commentFile'>
                  <label htmlFor={'select-images' + index}>
                    <span>
                      <img src='/assets/icons/camera.svg' alt='camera' />
                    </span>
                    <p>Choose file</p>
                  </label>
                  <input
                    className='inputFile'
                    id={'select-images' + index}
                    onChange={handleFile}
                    multiple
                    type='file'
                    accept='image/*'
                    disabled={readOnly}
                  />
                </div>
              ) : showImages?.preview && !item?.comment_files[0]?.url ? (
                // <div className="fillInspection__field-commentFile">
                //   <label htmlFor={"select-images" + index}>
                //   {/*{*/}
                //   {/*  showImages?.data?.map((img, i) => {*/}
                //   {/*    <img key={i} className="fillInspection__field-preview" src={img} alt="file"/>*/}
                //   {/*  })*/}
                //   {/*}*/}
                //     <img className="fillInspection__field-preview" src={showImages?.preview} alt="file"/>
                //   </label>
                //   <input
                //     className="inputFile"
                //     id={"select-images" + index}
                //     onChange={handleFile}
                //     multiple
                //     type="file"
                //     accept="image/*"
                //     disabled={readOnly}
                //   />
                // </div>
                <div className='fillInspection__field-commentImages'>
                  {renderImages()}
                </div>
              ) : !showImages?.preview && item?.comment_files[0]?.url ? (
                <div className='fillInspection__field-commentFile'>
                  <div className='fillInspection__field-commentImages'>
                    {item?.comment_files?.map((file, fileIndex) => (
                      <div
                        key={fileIndex}
                        className='fillInspection__field-commentImage'
                      >
                        {!readOnly && !disabled && (
                          <div
                            className='fillInspection__field-commentImageDel fillInspection__field-commentImageDel--visible'
                            onClick={() =>
                              removeCommentImage(fileIndex, true)
                            }
                            role='button'
                            aria-label='Remove image'
                          >
                            <img
                              src='/assets/icons/trash2.svg'
                              alt='trash'
                            />
                          </div>
                        )}
                        <img
                          className='fillInspection__field-commentImg'
                          src={file?.url}
                          alt=''
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : showImages?.preview && item?.comment_files[0]?.url ? (
                <div className='fillInspection__field-commentFile'>
                  <label htmlFor={'select-images' + index}>
                    <img
                      className='fillInspection__field-preview'
                      src={showImages?.preview}
                      alt='file'
                    />
                  </label>
                  <input
                    className='inputFile'
                    id={'select-images' + index}
                    onChange={handleFile}
                    multiple
                    type='file'
                    accept='image/*'
                    disabled={readOnly}
                  />
                </div>
              ) : null
            ) : (
              <div className='fillInspection__field-commentFile'>
                <label htmlFor={'select-images' + index}>
                  <span>
                    <img src='/assets/icons/camera.svg' alt='camera' />
                  </span>
                  <p>Choose file</p>
                </label>
                <input
                  className='inputFile'
                  id={'select-images' + index}
                  onChange={handleFile}
                  multiple
                  type='file'
                  accept='image/*'
                  disabled={readOnly}
                />
              </div>
            )}
          </div>
        )}
    </>
  );
}
